import AdminAddEntityTagPopover from "@/admin/settings/tabs/AdminAddEntityTagPopover"
import { AdminAddEntityTagPopoverContentProps } from "@/admin/settings/tabs/AdminAddEntityTagPopoverContent"
import {
  OverridableDiscoButton,
  OverridableDiscoButtonChildren,
} from "@disco-ui/button/OverridableDiscoButton"
import { TestIDProps } from "@utils/typeUtils"
import { useState } from "react"

type Props = TestIDProps &
  AdminAddEntityTagPopoverContentProps & {
    children: OverridableDiscoButtonChildren
  }

function AddEntityTagButton({
  testid = "AddEntityTagButton",
  children,
  skipCreation = false,
  ...popoverProps
}: Props) {
  const [anchorEl, setAnchorEl] = useState<null | Element>(null)

  return (
    <>
      <OverridableDiscoButton testid={`${testid}.add-tag-button`} onClick={onClick}>
        {children}
      </OverridableDiscoButton>

      {anchorEl && (
        <AdminAddEntityTagPopover
          anchorEl={anchorEl}
          skipCreation={skipCreation}
          onSelect={() => setAnchorEl(null)}
          onClose={() => setAnchorEl(null)}
          {...popoverProps}
        />
      )}
    </>
  )

  function onClick(event: React.MouseEvent) {
    setAnchorEl(event.currentTarget)
  }
}

export default AddEntityTagButton
